(function(){

    /* Load Script function we may need to load jQuery from the Google's CDN */
    /* That code is world-reknown. */
    /* One source: http://snipplr.com/view/18756/loadscript/ */
    
    var loadScript = function(url, callback){
     
      var script = document.createElement("script");
      script.type = "text/javascript";
    
      // If the browser is Internet Explorer.
      if (script.readyState){ 
        script.onreadystatechange = function(){
          if (script.readyState == "loaded" || script.readyState == "complete"){
            script.onreadystatechange = null;
            callback();
          }
        };
      // For any other browser.
      } else {
        script.onload = function(){
          callback();
        };
      }
    
      script.src = url;
      document.getElementsByTagName("head")[0].appendChild(script);
        
    };

    var myAppJavaScript = function($){
        
        var product;
        var selections = [];
        var dogName, dogDOB, dogGender;
        var animating = false;

        // Get the current product from Shopify
        jQuery.getJSON('/products/bowzer-box-subscription.js', function(data) { product = data; })
            .done(function() {
                init();
            })
            .fail(function() {
                console.log( "error" );
            })

        function init() {
            // Disable the add to cart button on enter
            $(window).keydown( function(evt) {
                if(evt.keyCode == 13) {
                    evt.preventDefault();
                    return false;
                }
            });

            // Set the next shipping date
            var nextShipment = nextShipDate();
            $(".shipping-date").text( nextShipment );

            // Focus on dog name to start
            $("#DogName").focus();

            // Handle dog's name
            $('#DogNameForm a').on('click', function(evt){
                // Stop form from submitting normally
                evt.preventDefault();

                dogName = $('#DogName').val();
                dogDOB = $('#DogDOB').val();
                dogGender = $('#DogGender').val();

                // Set the dog's name
                if (dogName == ''){
                    $(".dog-name-entered").html('&ndash;');
                    //$(".dog-name").text('your lucky pup');
                    $(".dog-name").each(function(){
                        $(this).text( $(this).data('default') )
                    })
                } else {
                    $(".dog-name-entered").text(dogName);
                    $(".dog-name").text(dogName);
                }

                // Set the DOB
                if (dogDOB == ''){
                    $(".dog-dob").html('&ndash;');
                } else {
                    $(".dog-dob").text(dogDOB);
                }

                // Set the gender
                if (dogGender == ''){
                    $(".dog-gender").html('&ndash;');
                    $(".dog-gender-label").text('he/she');
                } else {
                    $(".dog-gender").html(dogGender);
                    if (dogGender == 'Male') {
                        $(".dog-gender-label").text('he');
                    } else {
                        $(".dog-gender-label").text('she');
                    }
                }

                $('#DogNameForm').hide();
                $("#DogNameStatic").show();
                toggleSections($('#AboutTheDog'));
            });

            // Handle edit dog's name
            $('#DogNameStatic a').on('click', function(evt){
                // Stop form from submitting normally
                evt.preventDefault();
            
                $('#DogNameForm').show();
                $("#DogNameStatic").hide();
                $("#DogName").focus();
            });

            // Handle all the card click events
            $('.card').on('click', function(){

                // If we're in transition, don't allow click
                if (animating) { return false; }
                
                // Get the section
                var section = $(this).parent().parent();
                var sectionName = section.attr('id').toLowerCase();

                if ( sectionName == 'extratoy' ) {
                    
                    // handle this one differently
                    if ( $('.extratoy').text() == 'Yes' ) {
                        $(this).removeClass('selected');
                        section.find('.radio').text('radio_button_unchecked');
                        $('.extratoy').text('No');
                    } else {
                        $(this).addClass('selected');
                        $(this).find('.radio').text('check_circle');
                        $('.extratoy').text('Yes');
                    }                
                } else {
                    
                    if ( selections.indexOf(sectionName) == -1 ) { selections.push(sectionName); }
                    
                    // Remove previous selection
                    section.find('.card').removeClass('selected');
                    section.find('.radio').text('radio_button_unchecked');
                    
                    // Make the new selection
                    $(this).addClass('selected');
                    $(this).find('.radio').text('check_circle');
                    $('.' + section.attr('id').toLowerCase()).text( $(this).find('.card-title h3').text() );

                    // If they choose Chew'bacca, change the price
                    if ( sectionName == 'boxtype' ) {
                        if ( $(this).find('.card-title h3').text().toLowerCase() == "chew'bacca" ) {
                            $('.classic-price').addClass('hide');
                            $('.chewbacca-price').removeClass('hide');
                        } else {
                            $('.classic-price').removeClass('hide');
                            $('.chewbacca-price').addClass('hide');
                        }
                    }
                    
                    toggleSections(section);
                }

                if (selections.length > 3) { setVariant(); }
            });
        }

        // Show/hide sections
        function toggleSections(section) {
            
            // Show and scroll to next section
            if ($('#BoxDetails').hasClass('hide')) {
                nextSection = section.next('.section');
            
                if (nextSection.length !== 0) {
                    nextSection.removeClass('hide');
                    
                    animating = true;
                    $('html, body').animate({
                        scrollTop: nextSection.offset().top
                    }, 1000, function(){
                        animating = false;
                    });
                }
            }

            // Show the details after final selection
            if (selections.length > 3) { $('#BoxDetails').removeClass('hide'); }
        }

        // Calculate the variant
        function setVariant() {
            var opt1 = $('#DogSize .card.selected').data('variants');
            var opt2 = $('#BoxType .card.selected').data('variants');
            var opt3 = $('#Plan .card.selected').data('variants');
            var opt4 = ( $('#ExtraToy .card').hasClass('selected') ) ? $('#ExtraToy .card.selected').data('variantsyes') : $('#ExtraToy .card').data('variantsno');
            var id = [];
            
            id = intersection(opt1, opt2);
            id = intersection(id, opt3);
            id = intersection(id, opt4);
            
            // Find the price of the variant
            var price = 0;
            $.each( product.variants, function(i, variant){
                if ( variant.id == id[0] ) {
                    price = variant.price / 100;
                    return false;
                }
            });

            // Determine when the subscription auto-renews
            var plan = $('#Plan .card.selected').data('quantity').toFixed(0);
            var frequency = $('#Frequency .card.selected').data('frequency').toFixed(0);
            var renewal = plan*frequency;
            if (plan > 1) { renewal++; }
            
            $(".subtotal").html('$' + price.toFixed(2) + '<span>/box</span>');
            if ( renewal == 1 ) {
                $(".autorenew").text('Every month');
            } else {
                $(".autorenew").text('Every ' + renewal + ' months');
            }
            $("#id").val( id[0] );
            $("#dog_name").val(dogName);
            $("#dog_dob").val(dogDOB);
            $("#dog_gender").val(dogGender);
            $("#shipping_interval_frequency").val( $('#Frequency .card.selected').data('frequency') );
            $("#charge_interval_frequency").val( $('#Frequency .card.selected').data('frequency') );
            $("#number_charges_in_subscription").val($('#Plan .card.selected').data('quantity'));
        }

        function intersection (a, b) {
            var seen = a.reduce(function (h, k) {
              h[k] = true;
              return h;
            }, {});
          
            return b.filter(function (k) {
              var exists = seen[k];
              delete seen[k];
              return exists;
            });
        }

        // Get the next ship date
        function nextShipDate() {
            var cutoff_day = 10,
                ship_day_of_month = 15,
                today = moment().utcOffset(-240),
                next_shipment = moment().utcOffset(-240).date(ship_day_of_month);

            // Set the next shipping date
            if ( today.date() > cutoff_day ) {
                next_shipment.add(1, 'month')
            }

            return next_shipment.format('MMMM D, YYYY');
        }
    };
    
    /* If jQuery has not yet been loaded or if it has but it's too old for our needs,
    we will load jQuery from the Google CDN, and when it's fully loaded, we will run
    our app's JavaScript. Set your own limits here, the sample's code below uses 1.7
    as the minimum version we are ready to use, and if the jQuery is older, we load 1.9. */
    if ((typeof jQuery === 'undefined') || (parseFloat(jQuery.fn.jquery) < 1.7)) {
      loadScript('//ajax.googleapis.com/ajax/libs/jquery/1.9.1/jquery.min.js', function(){
        jQuery191 = jQuery.noConflict(true);
        myAppJavaScript(jQuery191);
      });
    } else {
      myAppJavaScript(jQuery);
    }
    
    })();